module.exports = "<svg viewBox=\"0 0 299.2 110.9\"><path d=\"M28.1 16.8l.2 41.2c-1.6-.3-3.2-.5-4.9-.5-6.2 0-12.1 2.4-16.5 6.8C2.4 68.8 0 74.7 0 80.9c0 12.9 10.5 23.4 23.4 23.4s23.4-10.5 23.4-23.4v-48L83 28.7v20.8c-1.6-.3-3.2-.5-4.9-.5-6.2 0-12.1 2.4-16.5 6.8s-6.8 10.3-6.8 16.5c0 12.9 10.5 23.4 23.4 23.4s23.4-10.5 23.4-23.4v-64l-73.5 8.5z\" class=\"st0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/icon-music.svg
// module id = 289
// module chunks = 1